module.exports = __webpack_public_path__ + "img/sb_2@2x.3651a8cf.png";